import { getLocale } from "@/data/regionInfo";
import { sha256 } from 'js-sha256';
import { external3DScene } from '@/mixins/external3DScene';

export default {
	data() {
    return {
      hideConfirmationModal: true,
      recipeIsLoading: false,
      clipboard: null,
      recaptchaResponse: '',
      addAnotherRecipients:[ { emailAddress: "" }],
      shareDesignFormData : {
        product_design_name: "",
        from_name: "",
        from_email: "",
        email: [],
        product_image_url: "",
        share_url: "",
        recipe_id: "",
        message: "",
        opt_in: true,
        region: "north-america",
        locale: ""
      }
    };
  },
  mixins: [external3DScene],
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    disableSendButton() {
      const missingRecipients = this.addAnotherRecipients.filter(
        ({ emailAddress }) => !this.isValidEmail(emailAddress)
      ).length;
      const validRecaptcha =  this.configuration?.enableRecaptcha === true ? !this.recaptchaVerified : false;
      const condition = (
        missingRecipients ||
        !this.shareDesignFormData.from_name ||
        !this.isValidEmail(this.shareDesignFormData.from_email) //||
        //validRecaptcha
      );
      if(this.configuration.modals.shareYourDesign) this.$emit('blockCtaPrimaryButton', condition);
      return condition;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    recaptchaKey() {
      return this.configuration.siteKeyRecaptcha || process.env.VUE_APP_RECAPTCH_SITE;
    },
    recaptchaVerified() {
      return !!this.$store.state.utils.recaptcha.verified ||
        ( !!this.$store.state.utils.recaptcha.response ||
        !!this.recaptchaResponse );
    },
    configuration() {
      return this.$store.state.utils.configuration;
    }
  },
  methods: {
    /**
     * @function resetScreenScrollPosition
     * Triggers the screen size calculations at Customizer.vue after the mobile keyboard is closed
     */
    resetScreenScrollPosition() {
      if (this.isMobile) this.$eventBus.$emit('recalculate-customizer-screen-size');
    },
    trackData(eventLabel) {
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerShareDesign,
          eventLabel
        });
      } else {
        dataLayer.push({
          event: "trackEvent",
          eventCategory: "customs",
          eventAction: "share",
          eventLabel
        });
      }
    },
    onMouseOut() {
      const element = this.configuration.modals.shareYourDesign ?
      document.getElementById('copyMessage') :
      this.$refs['copyMessage'];
      element.style.display = "none";
    },
    beforeOpen() {
      this.recipeIsLoading = true;
      this.$store
        .dispatch("recipe/SAVE_RECIPE", {
          recipe: this.$store.state.recipe.recipe_v2,
          requestParams: { locale: getLocale() }
        })
        .then(({ recipeId }) => {
          this.shareDesignFormData.recipe_id = recipeId;
          this.recipeIsLoading = false;
        })
        .catch(err => {
          console.error(err);
          if (err === 'InvalidRecipeError') this.$modal.hide('shareYourDesignModal');
        })
        .catch(console.error);
    },
    closeModal() {
      this.resetScreenScrollPosition();
      const modalName = this.configuration.modals.shareYourDesign ? 'shareYourDesign' : 'shareYourDesignModal';
      this.$modal.hide(modalName);
      this.trackData('Close Modal');
    },
    beforeClose() {
      this.shareDesignFormData.from_email = "";
      this.shareDesignFormData.from_name = "";
      this.shareDesignFormData.email = [];
      this.shareDesignFormData.message = "";
      this.addAnotherRecipients = [ { emailAddress: "" } ];
      this.hideConfirmationModal = true;
      this.$emit('showHideConfirmationModal', true);
    },
    copyLink() {
      this.trackData("Copy Link");
      const { recipe_id } = this.shareDesignFormData;
      const clipboardMessage = this.getShareURL(recipe_id);
      navigator.clipboard.writeText(clipboardMessage)
        .then(() => {
          const element = this.configuration.modals.shareYourDesign ?
            document.getElementById('copyMessage') :
            this.$refs['copyMessage'];
          element.style.display = "block";
          setTimeout(() => element.style.display = "none", 30000);
        })
        .catch(err => {
          window.prompt(this.translations.shareYourDesignCopyLinkM, clipboardMessage);
          console.error("Error copy Link:", err);
        });
    },
    getShareURL(recipeId) {
      let baseURL = this.$store.getters['utils/noEsiActive'] && window.parent ? window.parent.location.href : window.location.href;
      const recipeParameter =  `?recipe=${ recipeId }`;
      if (!baseURL.includes("?")) {
        baseURL += recipeParameter;
      } else {
        baseURL = baseURL.substring(0, baseURL.indexOf("?"));
        baseURL += recipeParameter;
      }
      baseURL = baseURL.replace("#","");
      return baseURL;
    },
    /**
     * @function getProductImage
     * This method gets the image url by featuredView.
     */
    async getProductImage() {
      const recipe = this.$store.state.recipe.recipe_v2;
      const { pdm } = this.$store.state.utils;
      let featuredView =
        typeof pdm.product_images.featured_views.sharing !== "undefined"
          ? pdm.product_images.featured_views.sharing
          : {
              view: "left",
              size: "md"
            };
      if(this.configuration.enableSnapshotService) {
        const data = await this.initExternal3Dscene({domEl: "snapshot-image-scene", snapshotSize: "md", snapshotView: "checkerboard_creator", showSnapShot: true});
        this.shareDesignFormData.product_image_url = data.fileUrl;
      }
  
      return new Promise((resolve) => {
        if(this.configuration.enableSnapshotService) {
          resolve();
        } else {
          this.$store
            .dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID", {
              recipe_id: recipe.recipe_id,
              locale: getLocale(),
              ...featuredView
            })
            .then(data => {
              this.shareDesignFormData.product_image_url =
                data[featuredView.view + "_view"][featuredView.size];
              resolve(data);
            })
            .catch(err => {
              console.error("Error getting product image:", err);
            });
        }
      });
    },
    /**
     * @function addRecipient
     * Adds recipient input field
     */
    addRecipient() {
      this.trackData("Add Another Recipient");
      // if user input is valid, adds input field, otherwise triggers html5 validations
      if (this.addAnotherRecipients.length < 10) {
        if (this.$refs.form.checkValidity()) {
          this.addAnotherRecipients.push({ emailAddress: "" });
        } else {
          this.$refs.form.reportValidity();
        }
      }
    },
    /**
     * @function removeRecipient
     * Removes recipient input field
     */
    removeRecipient(index) {
      this.addAnotherRecipients.splice(index, 1);
    },
    /**
     * @function getAnotherRecipients
     * This method returns the recipents array.
     */
    getAnotherRecipients() {
      let emails = [];
      for (let i = 0; i < this.addAnotherRecipients.length; i++) {
        emails.push(this.addAnotherRecipients[i].emailAddress);
      }
      return JSON.stringify(emails);
    },
    /**
     * @function sendMessage
     * This method call the getProduct image and then sent the email.
     */
    sendMessage() {
      const { recipe_id } = this.shareDesignFormData;
      this.shareDesignFormData.locale = getLocale();
      this.shareDesignFormData.share_url = this.getShareURL(recipe_id);
      this.shareDesignFormData.email = this.getAnotherRecipients();

      if(this.configuration.enableRecaptcha) {
        const { response } = this.$store.state.utils.recaptcha;
        this.shareDesignFormData["g-recaptcha-response"] = !!response ? response : this.recaptchaResponse;
      }
      this.getProductImage().then(() => {
        this.$store
          .dispatch("utils/SEND_GROUP_EMAIL", {
            data: this.shareDesignFormData
          })
          .then(() => {
            this.$store.commit("utils/SET_RECAPTCHA_PROPERTY", { element:"response", data: sha256(this.recaptchaResponse) });
            this.hideConfirmationModal = false;
            this.$emit('showHideConfirmationModal', false);
            this.trackData("Send to e-mail");
          })
          .catch(err => {
            console.error("Error sending email:", err);
          });
      });
    },
    /**
     * @function isValidEmail
     * This method validate the email address.
     */
    isValidEmail(emailAddress) {
      return this.$store.getters["utils/isValidEmail"]({
        email: emailAddress
      });
    },
    onVerifyRecaptcha(response) {
      this.recaptchaResponse = response;
      this.$store.commit("utils/SET_RECAPTCHA_PROPERTY", { element:"verified", data: true });
      if(this.configuration.modals.shareYourDesign) this.$emit('blockCtaPrimaryButton', this.disableSendButton);
    },
    errorRecaptcha(response) {
      console.error("Recaptcha error", response);
    }
  },
  created(){
    if(this.configuration.modals.shareYourDesign){
      this.$emit('blockCtaPrimaryButton', true);
      this.$emit('showHideConfirmationModal', true);
    }
  }
}